import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class Resolution1552Excel {
    exportExcel(data) {
        let option = {};  // La opción representa el archivo de Excel
        let resolution1552Data = this.resolution1552Patients(data);
        option.fileName = 'Resolucion 1552';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: resolution1552Data.data,  // Fuente de datos en archivo Excel
                sheetName: 'Resolucion 1552',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel

    }

    resolution1552Patients(dataResolution) {
        let dataTable = [];  // Contenido de datos en archivo Excel

        let Titulos = this.generarTituloResolucion();//Titulos del Recibo de Caja
        dataTable.push(Titulos);

        for(let i = 0; i < dataResolution.length; i++)
        {
            let Datos = this.generarDatosResolucion1552(dataResolution[i]);
            dataTable.push(Datos);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTituloResolucion() {
        let Titulos = {
            '1': 'Servicio',
            '2': "Total Citas Asignadas",
            '3': "Sumatoria Dias Asignación Cita",
            '4': "Sumatoria Dias Fecha Solicitada",
            '5': "Minimo Dias de Espera",
            '6': "Maximo Dias de Espera",
            '7': "Promedio Espera Asignacion",
            '8': "Promedio Espera Solicitud"
        }
        return Titulos;
    }

    generarDatosResolucion1552(data) {
        let Titulos = {
            '1': data.nombre_servicio,
            '2': data.total_citas,
            '3': data.sumatoriaDiasFechaAsignada,
            '4': data.sumatoriaDiasFechaSolicitada,
            '5': data.menorEsperaDias,
            '6': data.mayorEsperaDias,
            '7': data.promedioAsignacion,
            '8': data.promedioSolicitud
        }
        return Titulos;
    }

}

export default new Resolution1552Excel();